<section class="dbaas-hero">
  <div class="hero-background-elements">
    <div class="bg-element element-1"></div>
    <div class="bg-element element-2"></div>
    <div class="bg-element element-3"></div>
  </div>
  
  <div class="container mx-auto px-4 hero-content">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div class="text-center lg:text-left">
        <div class="inline-block bg-blue-500/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
          <span class="text-sm font-medium text-blue-300">
            <i class="bx bx-data mr-2"></i>Database as a Service
          </span>
        </div>
        
        <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          Managed <span class="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">Database Solutions</span>
        </h1>
        
        <p class="text-xl text-blue-100 mb-8 max-w-2xl mx-auto lg:mx-0">
          Deploy, scale, and manage enterprise-grade databases with zero infrastructure overhead. Focus on your applications while we handle database administration, maintenance, and optimization.
        </p>
        
        <div class="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-10">
          <a routerLink="/contact" class="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl inline-flex items-center justify-center">
            <i class="bx bx-phone mr-2"></i>
            Contact Us
          </a>
        </div>
        
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl mx-auto lg:mx-0 hero-features">
          <div class="bg-cyan-500/10 backdrop-blur-sm rounded-xl p-4 border border-cyan-500/30">
            <div class="text-3xl font-bold text-cyan-400 mb-1">99.99%</div>
            <div class="text-sm text-blue-200">Uptime SLA</div>
          </div>
          <div class="bg-cyan-500/10 backdrop-blur-sm rounded-xl p-4 border border-cyan-500/30">
            <div class="text-3xl font-bold text-cyan-400 mb-1">24/7</div>
            <div class="text-sm text-blue-200">DBA Support</div>
          </div>
          <div class="bg-cyan-500/10 backdrop-blur-sm rounded-xl p-4 border border-cyan-500/30">
            <div class="text-3xl font-bold text-cyan-400 mb-1">Auto</div>
            <div class="text-sm text-blue-200">Scaling</div>
          </div>
        </div>
      </div>
      
      <div class="hero-image">
        <div class="image-decoration">
          <div class="relative z-10 rounded-2xl overflow-hidden shadow-2xl border border-gray-700">
          <img src="assets/img/dbaas-hero.png" alt="Database as a Service" class="w-full h-auto object-cover">
        </div>
        </div>
        
        <div class="floating-card card-1">
          <i class="bx bx-shield-alt"></i>
          <span>Automated backups</span>
        </div>
        <div class="floating-card card-2">
          <i class="bx bx-trending-up"></i>
          <span>Live performance metrics</span>
        </div>
        <div class="floating-card card-3">
          <i class="bx bx-time-five"></i>
          <span>Point-in-time restore</span>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="py-20 bg-slate-900 text-white">
  <div class="container mx-auto px-4">
    <div class="text-center mb-14">
      <div class="inline-block bg-slate-800/80 border border-cyan-500/40 text-cyan-200 px-4 py-1 rounded-full text-sm font-medium mb-4">
        Service tiers and SLAs
      </div>
      <h2 class="text-3xl md:text-4xl font-bold mb-4">
        Managed database <span class="text-cyan-400">plans</span> for every workload
      </h2>
      <p class="text-blue-100 text-lg max-w-3xl mx-auto">
        Choose the right operational profile for development, production, or mission‑critical workloads with clearly defined performance,
        durability, and support guarantees.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
      <div class="rounded-2xl border border-slate-700 bg-slate-900/70 p-8 shadow-xl">
        <div class="mb-4 flex items-center justify-between">
          <div class="text-sm font-semibold tracking-wide text-cyan-300 uppercase">Standard</div>
          <span class="rounded-full bg-slate-800 px-3 py-1 text-xs text-slate-300">Dev / Test</span>
        </div>
        <p class="mb-6 text-sm text-blue-100">
          Cost‑optimized environments for development, testing, and non‑critical workloads.
        </p>
        <ul class="space-y-2 text-sm text-blue-100 mb-6">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-cyan-400 mr-2"></i>
            <span>Single‑AZ deployment</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-cyan-400 mr-2"></i>
            <span>Daily automated backups</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-cyan-400 mr-2"></i>
            <span>Business‑hours support</span>
          </li>
        </ul>
        <div class="flex items-center justify-between text-xs text-blue-200">
          <div>
            <div class="opacity-80">SLA</div>
            <div class="font-semibold text-white">99.5%</div>
          </div>
          <div>
            <div class="opacity-80">Retention</div>
            <div class="font-semibold text-white">7 days</div>
          </div>
        </div>
      </div>

      <div class="rounded-2xl border border-cyan-500 bg-slate-900/80 p-8 shadow-2xl scale-105">
        <div class="mb-4 flex items-center justify-between">
          <div class="text-sm font-semibold tracking-wide text-cyan-300 uppercase">Business Critical</div>
          <span class="rounded-full bg-cyan-500/20 text-cyan-100 px-3 py-1 text-xs">Most popular</span>
        </div>
        <p class="mb-6 text-sm text-blue-100">
          Highly available, production‑ready databases for core line‑of‑business applications.
        </p>
        <ul class="space-y-2 text-sm text-blue-100 mb-6">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-cyan-400 mr-2"></i>
            <span>Multi‑AZ replication</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-cyan-400 mr-2"></i>
            <span>Point‑in‑time recovery</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-cyan-400 mr-2"></i>
            <span>24/7 operational support</span>
          </li>
        </ul>
        <div class="flex items-center justify-between text-xs text-blue-200">
          <div>
            <div class="opacity-80">SLA</div>
            <div class="font-semibold text-white">99.99%</div>
          </div>
          <div>
            <div class="opacity-80">Retention</div>
            <div class="font-semibold text-white">35 days</div>
          </div>
        </div>
      </div>

      <div class="rounded-2xl border border-emerald-500/70 bg-slate-900/70 p-8 shadow-xl">
        <div class="mb-4 flex items-center justify-between">
          <div class="text-sm font-semibold tracking-wide text-emerald-300 uppercase">Enterprise</div>
          <span class="rounded-full bg-emerald-500/15 text-emerald-100 px-3 py-1 text-xs">Mission‑critical</span>
        </div>
        <p class="mb-6 text-sm text-blue-100">
          Maximum resilience and compliance for regulated, mission‑critical and large‑scale workloads.
        </p>
        <ul class="space-y-2 text-sm text-blue-100 mb-6">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-emerald-400 mr-2"></i>
            <span>Multi‑region replication</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-emerald-400 mr-2"></i>
            <span>Dedicated support team</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-emerald-400 mr-2"></i>
            <span>Enhanced compliance options</span>
          </li>
        </ul>
        <div class="flex items-center justify-between text-xs text-blue-200">
          <div>
            <div class="opacity-80">SLA</div>
            <div class="font-semibold text-white">99.995%</div>
          </div>
          <div>
            <div class="opacity-80">Retention</div>
            <div class="font-semibold text-white">90 days</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="py-20 bg-gray-50">
  <div class="container mx-auto px-4">
    <div class="text-center mb-16">
      <div class="inline-block bg-gradient-to-r from-cyan-100 to-blue-100 text-cyan-800 px-4 py-1 rounded-full text-sm font-medium mb-4">
        Database Features
      </div>
      <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        Enterprise <span class="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-blue-600">Database Capabilities</span>
      </h2>
      <p class="text-xl text-gray-600 max-w-3xl mx-auto">
        Comprehensive managed database services with enterprise-grade features designed for high availability, security, and performance.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-blue-100">
        <div class="w-16 h-16 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-shield text-3xl text-white"></i>
        </div>
        <div class="mb-3">
          <span class="bg-blue-100 text-blue-800 text-xs font-bold px-3 py-1 rounded-full">Security</span>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Advanced Security</h3>
        <p class="text-gray-600 mb-4">
          Enterprise-grade security with encryption at rest and in-transit, network isolation, and automated security patches.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">AES-256 encryption</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">TLS 1.3 encryption</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">VPC network isolation</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Automated security updates</span>
          </li>
        </ul>
      </div>

      <div class="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-cyan-100">
        <div class="w-16 h-16 bg-gradient-to-br from-cyan-600 to-blue-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-trending-up text-3xl text-white"></i>
        </div>
        <div class="mb-3">
          <span class="bg-cyan-100 text-cyan-800 text-xs font-bold px-3 py-1 rounded-full">Performance</span>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">High Performance</h3>
        <p class="text-gray-600 mb-4">
          Optimized database engines with NVMe SSD storage, intelligent caching, and automatic performance tuning.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">NVMe SSD storage</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Intelligent query optimization</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">In-memory caching</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Read replicas</span>
          </li>
        </ul>
      </div>

      <div class="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-purple-100">
        <div class="w-16 h-16 bg-gradient-to-br from-purple-600 to-pink-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-data text-3xl text-white"></i>
        </div>
        <div class="mb-3">
          <span class="bg-purple-100 text-purple-800 text-xs font-bold px-3 py-1 rounded-full">High Availability</span>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">99.99% Uptime</h3>
        <p class="text-gray-600 mb-4">
          Multi-zone replication, automatic failover, and redundant infrastructure ensure maximum availability.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Multi-zone replication</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Automatic failover</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">99.99% SLA guarantee</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Point-in-time recovery</span>
          </li>
        </ul>
      </div>

      <div class="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-green-100">
        <div class="w-16 h-16 bg-gradient-to-br from-green-600 to-emerald-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-sync text-3xl text-white"></i>
        </div>
        <div class="mb-3">
          <span class="bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full">Backup & Recovery</span>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Automated Backup</h3>
        <p class="text-gray-600 mb-4">
          Continuous backups with point-in-time recovery, cross-region replication, and one-click restore.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Continuous backups</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Point-in-time recovery</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Cross-region replication</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">One-click restore</span>
          </li>
        </ul>
      </div>

      <div class="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-amber-100">
        <div class="w-16 h-16 bg-gradient-to-br from-amber-600 to-orange-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-slider-alt text-3xl text-white"></i>
        </div>
        <div class="mb-3">
          <span class="bg-amber-100 text-amber-800 text-xs font-bold px-3 py-1 rounded-full">Scalability</span>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Auto Scaling</h3>
        <p class="text-gray-600 mb-4">
          Automatic vertical and horizontal scaling based on workload demands with zero downtime.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Vertical scaling</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Horizontal read scaling</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Storage auto-expansion</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Zero-downtime operations</span>
          </li>
        </ul>
      </div>

      <div class="bg-gradient-to-br from-rose-50 to-pink-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-rose-100">
        <div class="w-16 h-16 bg-gradient-to-br from-rose-600 to-pink-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-wrench text-3xl text-white"></i>
        </div>
        <div class="mb-3">
          <span class="bg-rose-100 text-rose-800 text-xs font-bold px-3 py-1 rounded-full">Management</span>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-3">Managed Service</h3>
        <p class="text-gray-600 mb-4">
          Full database administration including patching, monitoring, tuning, and 24/7 expert support.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Automated patching</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Performance monitoring</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Expert DBA support</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Health checks</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="py-20 bg-slate-900/30">
  <div class="container mx-auto px-4">
    <div class="text-center mb-16">
      <div class="inline-block bg-gradient-to-r from-indigo-100 to-blue-100 text-indigo-800 px-4 py-1 rounded-full text-sm font-medium mb-4">
        Supported Databases
      </div>
      <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        Database <span class="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-blue-600">Engine Options</span>
      </h2>
      <p class="text-xl text-gray-600 max-w-3xl mx-auto">
        Choose from popular relational and NoSQL database engines, each optimized for different workloads and use cases.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      <div class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-blue-100 text-center">
        <div class="w-16 h-16 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <i class="bx bxl-mysql text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-2">MySQL</h3>
        <p class="text-sm text-blue-600 font-semibold mb-4">8.0 / 5.7</p>
        <p class="text-gray-600 mb-6">
          The world's most popular open-source relational database with high performance and reliability.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center justify-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">High availability</span>
          </li>
          <li class="flex items-center justify-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Read replicas</span>
          </li>
          <li class="flex items-center justify-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Automated backups</span>
          </li>
        </ul>
      </div>

      <div class="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-cyan-100 text-center">
        <div class="w-16 h-16 bg-gradient-to-br from-cyan-600 to-blue-700 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <i class="bx bxl-postgresql text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-2">PostgreSQL</h3>
        <p class="text-sm text-cyan-600 font-semibold mb-4">14 / 13 / 12</p>
        <p class="text-gray-600 mb-6">
          Advanced open-source relational database with powerful features and extensibility.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center justify-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Point-in-time recovery</span>
          </li>
          <li class="flex items-center justify-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Logical replication</span>
          </li>
          <li class="flex items-center justify-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Extensions support</span>
          </li>
        </ul>
      </div>

      <div class="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-purple-100 text-center">
        <div class="w-16 h-16 bg-gradient-to-br from-purple-600 to-pink-700 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <i class="bx bxl-mongodb text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-2">MongoDB</h3>
        <p class="text-sm text-purple-600 font-semibold mb-4">5.0 / 4.4</p>
        <p class="text-gray-600 mb-6">
          Document-oriented NoSQL database designed for scalability and developer productivity.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center justify-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Horizontal scaling</span>
          </li>
          <li class="flex items-center justify-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Aggregation framework</span>
          </li>
          <li class="flex items-center justify-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Replica sets</span>
          </li>
        </ul>
      </div>

      <div class="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-green-100 text-center">
        <div class="w-16 h-16 bg-gradient-to-br from-green-600 to-emerald-700 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <i class="bx bx-data text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-2">Redis</h3>
        <p class="text-sm text-green-600 font-semibold mb-4">6.2 / 6.0</p>
        <p class="text-gray-600 mb-6">
          In-memory data structure store, used as database, cache and message broker.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center justify-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">High performance</span>
          </li>
          <li class="flex items-center justify-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Persistence options</span>
          </li>
          <li class="flex items-center justify-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Pub/Sub messaging</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="py-20 bg-gray-50">
  <div class="container mx-auto px-4">
    <div class="text-center mb-16">
      <div class="inline-block bg-gradient-to-r from-cyan-100 to-blue-100 text-cyan-800 px-4 py-1 rounded-full text-sm font-medium mb-4">
        Database Use Cases
      </div>
      <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        Database <span class="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-blue-600">Solutions for Every Need</span>
      </h2>
      <p class="text-xl text-gray-600 max-w-3xl mx-auto">
        Discover how our managed database services power diverse applications, from e-commerce platforms to real-time analytics.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
      <div class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-blue-100">
        <div class="flex items-start mb-6">
          <div class="w-14 h-14 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-xl flex items-center justify-center mr-4">
            <i class="bx bx-cart text-2xl text-white"></i>
          </div>
          <div>
            <div class="inline-block bg-blue-100 text-blue-800 text-xs font-bold px-3 py-1 rounded-full mb-2">E-commerce</div>
            <h3 class="text-xl font-bold text-gray-900">E-commerce Platforms</h3>
          </div>
        </div>
        <p class="text-gray-600 mb-6">
          High-performance databases for product catalogs, customer data, and transaction processing with ACID compliance and horizontal scaling.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">ACID transactions</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Real-time inventory</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Customer analytics</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Payment processing</span>
          </li>
        </ul>
        <div class="grid grid-cols-2 gap-4 pt-4 border-t border-gray-200">
          <div>
            <div class="text-sm text-gray-600">Uptime:</div>
            <div class="font-semibold text-gray-900">99.99%</div>
          </div>
          <div>
            <div class="text-sm text-gray-600">Latency:</div>
            <div class="font-semibold text-gray-900">&lt; 10ms</div>
          </div>
        </div>
      </div>

      <div class="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-cyan-100">
        <div class="flex items-start mb-6">
          <div class="w-14 h-14 bg-gradient-to-br from-cyan-600 to-blue-700 rounded-xl flex items-center justify-center mr-4">
            <i class="bx bx-bar-chart-alt-2 text-2xl text-white"></i>
          </div>
          <div>
            <div class="inline-block bg-cyan-100 text-cyan-800 text-xs font-bold px-3 py-1 rounded-full mb-2">Analytics</div>
            <h3 class="text-xl font-bold text-gray-900">Business Intelligence</h3>
          </div>
        </div>
        <p class="text-gray-600 mb-6">
          Powerful analytical databases with columnar storage, parallel processing, and advanced analytics capabilities for data-driven insights.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Columnar storage</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Parallel processing</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Real-time analytics</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Data warehousing</span>
          </li>
        </ul>
        <div class="grid grid-cols-2 gap-4 pt-4 border-t border-gray-200">
          <div>
            <div class="text-sm text-gray-600">Scale:</div>
            <div class="font-semibold text-gray-900">PB</div>
          </div>
          <div>
            <div class="text-sm text-gray-600">Availability:</div>
            <div class="font-semibold text-gray-900">99.99%</div>
          </div>
        </div>
      </div>

      <div class="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-purple-100">
        <div class="flex items-start mb-6">
          <div class="w-14 h-14 bg-gradient-to-br from-purple-600 to-pink-700 rounded-xl flex items-center justify-center mr-4">
            <i class="bx bx-mobile text-2xl text-white"></i>
          </div>
          <div>
            <div class="inline-block bg-purple-100 text-purple-800 text-xs font-bold px-3 py-1 rounded-full mb-2">Mobile Apps</div>
            <h3 class="text-xl font-bold text-gray-900">Mobile Applications</h3>
          </div>
        </div>
        <p class="text-gray-600 mb-6">
          Scalable databases optimized for mobile workloads with low-latency access, offline synchronization, and global distribution.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Global distribution</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Offline sync</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Push notifications</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">User personalization</span>
          </li>
        </ul>
        <div class="grid grid-cols-2 gap-4 pt-4 border-t border-gray-200">
          <div>
            <div class="text-sm text-gray-600">Users:</div>
            <div class="font-semibold text-gray-900">10M+</div>
          </div>
          <div>
            <div class="text-sm text-gray-600">Latency:</div>
            <div class="font-semibold text-gray-900">&lt; 5ms</div>
          </div>
        </div>
      </div>

      <div class="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-green-100">
        <div class="flex items-start mb-6">
          <div class="w-14 h-14 bg-gradient-to-br from-green-600 to-emerald-700 rounded-xl flex items-center justify-center mr-4">
            <i class="bx bx-globe text-2xl text-white"></i>
          </div>
          <div>
            <div class="inline-block bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full mb-2">Web Apps</div>
            <h3 class="text-xl font-bold text-gray-900">Web Applications</h3>
          </div>
        </div>
        <p class="text-gray-600 mb-6">
          Reliable databases for content management, user authentication, session management, and dynamic content delivery with high availability.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Session management</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">User authentication</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Content storage</span>
          </li>
          <li class="flex items-center text-gray-700">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Caching layer</span>
          </li>
        </ul>
        <div class="grid grid-cols-2 gap-4 pt-4 border-t border-gray-200">
          <div>
            <div class="text-sm text-gray-600">Scaling:</div>
            <div class="font-semibold text-gray-900">Auto</div>
          </div>
          <div>
            <div class="text-sm text-gray-600">Monitoring:</div>
            <div class="font-semibold text-gray-900">24/7</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="relative bg-gradient-to-br from-cyan-600 via-blue-700 to-indigo-800 text-white overflow-hidden py-20">
  <div class="absolute inset-0 z-0">
    <div class="absolute top-0 right-0 w-96 h-96 bg-cyan-400 rounded-full filter blur-3xl opacity-20 animate-pulse"></div>
    <div class="absolute bottom-0 left-0 w-96 h-96 bg-blue-400 rounded-full filter blur-3xl opacity-20 animate-pulse"></div>
  </div>
  
  <div class="container mx-auto px-4 relative z-10">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div>
        <h2 class="text-3xl md:text-4xl font-bold mb-6">Ready to Deploy Managed Databases?</h2>
        <p class="text-xl text-blue-100 mb-8">
          Launch your database instance with enterprise features, automated management, and 24/7 expert support. Focus on your applications while we handle the database complexity.
        </p>
        
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div class="flex items-center">
            <div class="bg-white/20 backdrop-blur-sm p-3 rounded-lg mr-4">
              <i class="bx bx-rocket text-2xl"></i>
            </div>
            <div>
              <div class="font-semibold">Deploy in 60s</div>
              <div class="text-sm text-blue-200">Fast setup</div>
            </div>
          </div>
          
          <div class="flex items-center">
            <div class="bg-white/20 backdrop-blur-sm p-3 rounded-lg mr-4">
              <i class="bx bx-support text-2xl"></i>
            </div>
            <div>
              <div class="font-semibold">24/7 DBA Experts</div>
              <div class="text-sm text-blue-200">Expert support</div>
            </div>
          </div>
          
          <div class="flex items-center">
            <div class="bg-white/20 backdrop-blur-sm p-3 rounded-lg mr-4">
              <i class="bx bx-conversation text-2xl"></i>
            </div>
            <div>
              <div class="font-semibold">Pricing Info</div>
              <div class="text-sm text-blue-200">Contact us</div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="space-y-4">
        <a routerLink="/contact" class="block bg-slate-800/30 text-white font-bold py-4 px-6 rounded-xl text-center hover:bg-slate-700/30 transition-all duration-300 transform hover:-translate-y-1 shadow-xl hover:shadow-2xl">
          <i class="bx bx-phone text-xl mr-2"></i>
          <span class="text-lg">Contact Us</span>
          <div class="text-sm font-normal text-gray-600 mt-1">Get pricing information</div>
        </a>
        
        <a routerLink="/contact" class="block bg-transparent border-2 border-slate-700/50 text-white font-bold py-4 px-6 rounded-xl text-center hover:bg-slate-700/20 transition-all duration-300">
          <i class="bx bx-phone text-xl mr-2"></i>
          <span class="text-lg">Contact Sales Team</span>
          <div class="text-sm font-normal text-blue-200 mt-1">Get custom solutions</div>
        </a>
        
        <div class="bg-slate-800/30 backdrop-blur-sm rounded-xl p-4 text-center border border-slate-700/30">
          <i class="bx bx-shield-check text-3xl mb-2"></i>
          <div class="font-semibold">99.99% Uptime SLA Guaranteed</div>
        </div>
      </div>
    </div>
  </div>
</section>
